import { useEffect } from "react";
import { getCalApi } from "@calcom/embed-react";

// Cal.com username/team slug for booking links.
export const CAL_USER = "nicholas-lovett-7280g2";

// Available event types -> Cal.com event slugs.
export const CAL_EVENTS = {
    "15min": "15min",
    "30min": "30min"
};

/**
 * Wires up a Cal.com popup for the given event type and returns the data
 * attributes to spread onto any clickable element.
 *
 * The overlay is always rendered in Cal's dark theme: both site modes are dark
 * terminal screens (Pip-Boy Green and Vault-Tec Amber), so the `light` theme key
 * describes the phosphor, not the luminance.
 *
 * Usage:
 *   const calProps = useCalPopup("30min");
 *   <button {...calProps}>Book a Call</button>
 */
export const useCalPopup = (event = "30min") => {
    const mode = "dark";

    useEffect(() => {
        let active = true;
        (async () => {
            const cal = await getCalApi({ namespace: event });
            if (!active) return;
            cal("ui", {
                theme: mode,
                hideEventTypeDetails: false,
                layout: "month_view"
            });
        })();
        return () => {
            active = false;
        };
    }, [event]);

    return {
        "data-cal-namespace": event,
        "data-cal-link": `${CAL_USER}/${CAL_EVENTS[event] || event}`,
        "data-cal-config": JSON.stringify({ layout: "month_view", theme: mode })
    };
};
